import { useCallback, useEffect, useMemo, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import CustomModal from '@/components/shared/CustomModal/CustomModal'
import { Table } from '@components/shared/Table'
import './ViewTractRunsheetsModal.css'

export const EditAssignedTractListModal = ({
    assignedTracts,
    show,
    setShow,
    
    // setTracts,
    isButton = true,
    setAssignTractsList,
    setIsAddTract,
    
    // isAddTract,
    project,
    onAddTract,
    onRemoveTract,
}) => {
    
    const [checkedTractIds, setCheckedTractIds] = useState({})
    
    const tracts = useWireValue(store.tracts)
    
    const toggleOpen = () => setShow(!show)
    
    useEffect(() => {
        actions.fetchTracts()
    }, [])
    
    useEffect(() => {
        
        if (!assignedTracts) return
        
        setCheckedTractIds(assignedTracts.reduce((acc, it) => ({
            ...acc,
            [it.id]: true,
        }), {}))
        
    }, [assignedTracts])
    
    const onCheckboxChange = useCallback((checked, tract) => {
        
        const values = { ...checkedTractIds }
        
        if (checked) {
            values[tract.id] = true
            onAddTract(tract)
        } else {
            values[tract.id] = false
            onRemoveTract(tract)
        }
        
        setCheckedTractIds(values)
        
    }, [checkedTractIds, onAddTract, onRemoveTract])
    
    const rows = useMemo(() => tracts?.map(tract => {
        
        let assignedTo = ''
        
        if (tract.assignedTo?.length)
            assignedTo = `${tract.assignedTo[0].firstName || ''} ${tract.assignedTo[0].lastName || ''}`
        
        return [
            <input
                key={`tract-row-checkbox-${tract.id}`}
                type="checkbox"
                className="checkbox-user"
                value={tract.id}
                name={`tract-${tract.id}`}
                checked={checkedTractIds[tract.id]}
                onChange={e => onCheckboxChange(e.target.checked, tract)} />,
            tract.name || '',
            `${tract.grossAcreage || ''}`,
            assignedTo,
            tract?.county?.name || '',
        ]
        
    }), [tracts, onCheckboxChange, checkedTractIds])
    
    return (
        
        <CustomModal
            modalClass="assign-tract-to-runsheet"
            open={show}
            modalHandler={() => toggleOpen()}
            center>
            
            <div className="modal-header">
                <h2 className="modal-title">Edit Assigned Tracts List</h2>
            </div>
            
            <div
                className="p-2 modal-body"
                style={{
                    height: '360px',
                    overflow: 'auto',
                }}>
                
                {show && (
                    <Table
                        setIsAddTract={setIsAddTract}
                        isButton={isButton}
                        setShowTable={value => setShow(value)}
                        setAssignTractsList={setAssignTractsList}
                        prefix="tracts-list"
                        headers={['', 'Tract Name', 'Gross Acreage', 'Assigned to', 'County']}
                        sortHeaders={[
                            'item-state',
                            'item-timestamp',
                            'item-firstName',
                            'item-lastName',
                            'item-county',
                        ]}
                        rows={rows}
                        tracts={assignedTracts}
                        project={project} />
                )}
            
            </div>
            
            <div className="modal-footer flex justify-between"></div>
        
        </CustomModal>
        
    )
}
